import styled from 'styled-components';

export const UiSessionReportPage = styled.div`
	max-width: 1270px;
	width: 70vw;
	display: block;
	box-sizing: border-box;
	margin: 0 auto;
	padding-top: 35px;
`;